// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jffK0","tabsBox":"styles_tabsBox__clVD7","createButton":"styles_createButton__1e41s"};